import axios from 'axios';
import { getActiveAccountId, loadSessions, saveSessions, setActiveSession, migrateLegacyUserInfoIfNeeded, syncLegacyStorageFromActive } from './utils/accountSessions';

// Global axios setup to use HttpOnly cookie-based auth
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Accept'] = 'application/json';

migrateLegacyUserInfoIfNeeded();
syncLegacyStorageFromActive();

const API_URL = process.env.REACT_APP_API_URL;

async function bootstrapAccountsFromCookies() {
  if (!API_URL) return;
  if (getActiveAccountId()) return;

  try {
    const res = await axios.get(API_URL + 'auth/accounts');
    const accounts = res?.data?.accounts;
    if (!Array.isArray(accounts) || accounts.length === 0) return;

    const sessions = accounts.map((a) => ({
      id: a.id,
      role: a.role,
      user: a.user,
      doctor: a.doctor,
      addedAt: new Date().toISOString(),
    }));

    saveSessions(sessions);
    setActiveSession(sessions[0].id);
  } catch (_) {}
}

bootstrapAccountsFromCookies();

axios.interceptors.request.use((config) => {
  config.withCredentials = true;

  const activeAccountId = getActiveAccountId() || (loadSessions()[0]?.id ? String(loadSessions()[0].id) : null);

  if (!config.headers) {
    config.headers = {};
  }

  if (activeAccountId && !Object.prototype.hasOwnProperty.call(config.headers, 'X-Account-Id')) {
    config.headers['X-Account-Id'] = String(activeAccountId);
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      if (!currentPath.includes('/control/login')) {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('accountSessions');
        localStorage.removeItem('activeAccountId');
        window.location.href = '/control/login';
      }
    }
    return Promise.reject(error);
  }
);
